import React from 'react';
import { ProgressBar as Bar } from 'react-bootstrap';

interface ProgressBarProps {
  now: number;
}

const getProgressBarGradient = (progress: number): string => {
  if (progress <= 50) {
    return 'linear-gradient(90deg, #28a745 0%, #3bc65c 100%)';
  }
  if (progress <= 75) {
    return 'linear-gradient(90deg, #3bc65c 0%, #f7c948 100%)';
  }
  return 'linear-gradient(90deg,  #3bc65c 0%, #f7c948 75%, #f54e4e 100%)';
};

/**
 * Single task card component for task list.
 */
const ProgressBar: React.FC<ProgressBarProps> = ({ now }) => {
  return (
    <Bar
      now={100}
      style={{
        height: '0.5rem',
        background: 'var(--bs-light)',
      }}
    >
      <Bar
        now={now}
        style={{
          background: getProgressBarGradient(now),
        }}
      />
    </Bar>
  );
};

export default ProgressBar;
export type { ProgressBarProps };
